<script lang="ts">
	import { menuBlockIn } from '$lib/animations/MenuTransitions';
	import type { GlobalSettingsType } from '$lib/queries/GlobalSettingsQuery';
	import CustomIcon from '@atoms/CustomIcon.svelte';
	import Theme from '@tools/styles/Theme.svelte';

	let {
		data,
		index
	}: {
		data: GlobalSettingsType['menus'][0]['blocks'][0];
		index: number;
	} = $props();

	const theme = new Theme(data.colorTheme ? data.colorTheme : index * 2);
</script>

<a {...data.link} style={theme.css} in:menuBlockIn|global>
	<CustomIcon name={data.title} />
	<h3 class="text:h4">{data.title}</h3>
</a>

<style lang="scss">
	a {
		display: flex;
		flex-direction: row;
		align-items: center;
		background-color: var(--theme-primary);
		color: var(--theme-foreground);
		padding: $gap4 var(--gutter);
		gap: $gap1;
		text-decoration: none;

		:global(svg) {
			width: 2.273rem;
			height: 2.273rem;
		}
	}
</style>
